import React from 'react';

const PagoMercadoPago = () => {
    return (
        <>
            <div>
            </div>
        </>
    );
};

export { PagoMercadoPago };
